import {Component as $iLYtj$Component} from "react";
import {hyperStyled as $iLYtj$hyperStyled} from "@macrostrat/hyper";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;



var $aVUB5 = parcelRequire("aVUB5");

var $gziYm = parcelRequire("gziYm");

var $38gjf = parcelRequire("38gjf");

var $cJZBk = parcelRequire("cJZBk");
const $d1c6cd8a9e2bc95d$var$h = (0, $iLYtj$hyperStyled)((0, (/*@__PURE__*/$parcel$interopDefault($cJZBk))));
const $d1c6cd8a9e2bc95d$var$FaciesRow = ({ facies: facies })=>$d1c6cd8a9e2bc95d$var$h("span.facies-picker-row", [
        $d1c6cd8a9e2bc95d$var$h((0, $gziYm.BasicFaciesSwatch), {
            facies: facies,
            className: "facies-color-swatch"
        }),
        $d1c6cd8a9e2bc95d$var$h("span.facies-picker-name", facies.name)
    ]);
class $d1c6cd8a9e2bc95d$export$f2b9950aa847eed7 extends (0, $iLYtj$Component) {
    static #_ = this.contextType = (0, $aVUB5.FaciesContext);
    render() {
        const { facies: facies } = this.context;
        const { interval: interval, onChange: onChange } = this.props;
        const options = facies.map((f)=>({
                value: f.id,
                label: $d1c6cd8a9e2bc95d$var$h($d1c6cd8a9e2bc95d$var$FaciesRow, {
                    facies: f
                })
            }));
        let value = options.find((d)=>d.value === interval.facies);
        if (value == null) value = null;
        return $d1c6cd8a9e2bc95d$var$h((0, $38gjf.RaisedSelect), {
            id: "facies-select",
            options: options,
            value: value,
            selected: interval.facies,
            isClearable: true,
            onChange (res) {
                console.log("Changing", res);
                const f = res != null ? res.value : null;
                return onChange(f);
            }
        });
    }
}


//# sourceMappingURL=picker.93f595d7.js.map
